import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          {/* About Section */}
          <div className="footer-section">
            <h3 className="footer-title">San Kai Karate</h3>
            <p className="footer-text">
              Is your child energetic? Looking for fun and fitness? Come and give San Kai a try. Quality karate instruction in Clacton-on-Sea.
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/profile.php?id=61573768042631" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Club</Link></li>
              <li><Link to="/schedule">Schedule</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/instructors">Instructors</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-title">Contact Us</h3>
            <ul className="footer-contact">
              <li>
                <MapPin size={16} />
                <span>Brotherhood Hall, St Oysth Road (Fri)</span>
              </li>
              <li>
                <Phone size={16} />
                <span>Paul Rees: 07576 327340</span>
              </li>
              <li>
                <Mail size={16} />
                <span>Facebook: San Kai Karate</span>
              </li>
            </ul>
          </div>

          {/* Affiliations */}
          <div className="footer-section">
            <h3 className="footer-title">Our Affiliations</h3>
            <ul className="affiliations-list">
              <li>English Karate Federation (EKF)</li>
              <li>English Karate Organisation (EKO)</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 San Kai Karate. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;